/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Scope_UndefinedInputs */

const en_enum_setting_scope_undefined = /** @type {(inputs: Enum_Setting_Scope_UndefinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope Undefined`)
};

const de_enum_setting_scope_undefined = /** @type {(inputs: Enum_Setting_Scope_UndefinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undefined`)
};

/**
* | output |
* | --- |
* | "Scope Undefined" |
*
* @param {Enum_Setting_Scope_UndefinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_scope_undefined = /** @type {((inputs?: Enum_Setting_Scope_UndefinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Scope_UndefinedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_scope_undefined(inputs)
	return de_enum_setting_scope_undefined(inputs)
});